export default __webpack_public_path__ + "static/Lauren@2x-be0423020f0146a9c3d0af12c5055adc.png";